module.exports = __webpack_public_path__ + "img/logo_icon.ae4ad242.png";